import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsMTACardShipmentSchoolParmInfo } from "./wsMTACardShipmentSchoolParmInfo";
import { wsMTACardShipmentSchoolReceiveUpdateParmInfo } from "./wsMTACardShipmentSchoolReceiveUpdateParmInfo";

@Injectable()
export class DataService_mtacardmanager {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MTACardShipmentSchoolSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	MTACardShipmentSchoolSelectList(parms: wsMTACardShipmentSchoolParmInfo) {
		var postResult$ = new Subject();
		var url = "MTACardManager/MTACardShipmentSchoolSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MTACardShipmentSchoolReceiveDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	MTACardShipmentSchoolReceiveDataGet(MTACardShipmentID: number) {
		var postResult$ = new Subject();
		var url = "MTACardManager/MTACardShipmentSchoolReceiveDataGet";

		var promise$ = this.httpclientService.post(url, MTACardShipmentID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MTACardShipmentSchoolReceiveUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	MTACardShipmentSchoolReceiveUpdate(parms: wsMTACardShipmentSchoolReceiveUpdateParmInfo) {
		var postResult$ = new Subject();
		var url = "MTACardManager/MTACardShipmentSchoolReceiveUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
